<template>
  <RasterLayer :layerId="layerId" :layer="layerStyle" :sourceId="sourceId" :source="source" />
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import RasterLayer from '@/components/map/mapbox-layers/RasterLayer.vue'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_IS_SATELLITE_ACTIVE } from '@/store/mutation-types'

export default {
  name: 'LayerSatellite',
  components: {
    RasterLayer
  },
  props: {},
  data() {
    return {
      sourceId: 'SatelliteSourceId',
      layerId: 'layer-satellite',
      source: {
        type: 'raster',
        url: 'mapbox://mapbox.satellite'
      }
    }
  },
  computed: {
    ...mapState(MAPVIEW_PREFIX, {
      isSatelliteActive: (state) => state.isSatelliteActive
    }),
    ...mapGetters({
      isMapviewShowing: 'isMapviewShowing'
    }),
    layerStyle() {
      return {
        id: this.layerId,
        source: this.sourceId,
        type: 'raster',
        paint: {
          'raster-opacity': 1
        },
        layout: {
          visibility: this.isSatelliteActive ? 'visible' : 'none'
        }
      }
    }
  },
  watch: {
    isMapviewShowing(n) {
      if (!n) this.setIsSatelliteActive({ value: false })
    }
  },
  methods: {
    ...mapMutations(MAPVIEW_PREFIX, {
      setIsSatelliteActive: SET_IS_SATELLITE_ACTIVE
    })
  }
}
</script>
